import {
  Box,
  Flex,
  Heading,
  HStack,
  Image,
  ListItem,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import Copyright from "../../../../components/Sm/Copyright";
import Grid from "../../../../components/Sm/Grid";

interface IReport {
  item?: any;
}

const Report6ChartTwo: React.FC<IReport> = ({ item }) => {
  const pageChallengeList = item?.pageChallenge.split(";");
  const remedyList = item?.remedy.split(";");
  return (
    <Box
      className="page-break"
      h="auto"
      overflow="hidden"
      w="full"
      position="relative"
    >
      <HStack align="center" justify="center" w="full" pos="relative">
        <Copyright />
        <Grid text={item?.GNPN} />
      </HStack>
      <VStack align="left" py={[5, 10]} gap={[3, 5]} textAlign="left">
        <Flex justify="space-between" align="center" pb={[2, 3]}>
          <HStack spacing={[2, 3]}>
            <Box w={["10", "10"]} h={[10, 10]} bg={`${item?.box_color}`}></Box>
            <Heading fontSize={["16px", "25px"]} textTransform="uppercase">
              {item?.pageTitle}
            </Heading>
          </HStack>
          <Image
            src={`/uploads/${item?.logoOne ? item?.logoOne : item?.logoTwo}`}
            w={["16", "20"]}
            h={["16", "20"]}
            alt="image"
          />
        </Flex>
        <VStack spacing={6} w="full" align="left">
          <VStack align="left">
            <Heading
              textTransform="uppercase"
              fontWeight="500"
              fontSize={["15px", "17px"]}
            >
              challenge:
            </Heading>
            <UnorderedList pl={[4, 7]}>
              {pageChallengeList.map((i: any, index: any) => (
                <ListItem key={index}>{i}</ListItem>
              ))}
            </UnorderedList>
          </VStack>
          <VStack align="left" textAlign="left">
            <Heading
              textTransform="uppercase"
              fontWeight="500"
              fontSize={["15px", "17px"]}
            >
              Remedy:
            </Heading>
            <UnorderedList pl={[4, 7]}>
              {remedyList.map((i: any, index: any) => (
                <ListItem key={index}>{i}</ListItem>
              ))}
            </UnorderedList>
          </VStack>
          <Heading
            fontSize={["16px", "20px"]}
            fontWeight="600"
            textTransform="uppercase"
            textAlign="center"
          >
            {item?.downBoldText}
          </Heading>
        </VStack>
      </VStack>
    </Box>
  );
};

export default Report6ChartTwo;
